export type ColorParam = string | ArrayLike<number> | number | Record<string, any>

export enum ColorVariable {
  Primary = 'primary',
  PrimaryContrast = 'primaryContrast',
}

export type Theme = Record<ColorVariable, ColorParam>
